import styled from "styled-components";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
const isB2U = process.env.GATSBY_BUSINESS_VERTICAL === "b2u";
export const PortfolioWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	.text-container {
		display: flex;
		flex-direction: column;
		margin: 0 0 1rem 1rem;
		&:only-child {
			margin-left: 0;
		}
	}
	.description {
		padding-right: 2rem;
	}
	.user-details {
		display: flex;
		& p {
			margin: 0 0 0.5rem 0;
		}
		img {
			border-radius: 50%;
		}
	}
	.cover-image img {
		width: 100%;
		padding-right: 2rem;
	}
	p.description {
		margin: 0.5rem 0;
	}
	.link {
		margin: 0 !important;
	}
	p.link-text {
		${({ linkColor }) =>
			isB2U && linkColor ? `color: ${linkColor} !important;` : ""}
	}
	.link svg > path {
		${({ linkColor }) =>
			isB2U && linkColor ? `fill: ${linkColor}; !important` : ""}
	}

	${() => {
		if (isB2U) {
			return `
             p.link-text {
                color: ${({ isDarkBackground, linkColor }) =>
									linkColor
										? `${linkColor} !important`
										: isDarkBackground
											? "var(--secondary-purple-100)"
											: "var(--secondary-purple-300)"};
            }
            .link svg > path {
            fill: ${({ isDarkBackground, linkColor }) =>
							linkColor
								? linkColor
								: isDarkBackground
									? "var(--secondary-purple-100)"
									: "var(--secondary-purple-300)"};
    }
            `;
		}
	}}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		&:nth-child(odd) {
			border-right: 0px;
		}
		&:not(:last-child) {
			border-bottom: 1px solid var(--secondary-gray-medium);
		}
		.cover-image img {
			padding-right: 0rem;
		}
		.user-details {
			margin-top: 1.5rem;
		}
	}
`;
